import { Button, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from "@mui/material";
import { useState, useEffect, useContext } from "react";
import UseInfoMain from "../components/UseInfoMain";
import UseInfoBirthday from "../components/UseInfoBirthday";
import PictureUpload from "../components/PictureUpload";
import UseInfoPassport from "../components/UseInfoPassport";
import UseInfoOthers from "../components/UseInfoOthers";
import UseInfoEmail from "../components/UseInfoEmail";
import UserInfoEmergency from "../components/UserInfoEmergency";
import { useNavigate } from "react-router-dom"; // useNavigateをインポート
import { imgPath, gasPath, TokenContext, restPath, prefix } from './../App';
/**
 *
 * @returns 新規登録
 */
const Register = () => {
  const navigate = useNavigate();
  const token = useContext(TokenContext);
  const storedData = sessionStorage.getItem("jacUserCore");
  const [userInfo, setUserInfo] = useState([]);
  const [isUpdated, setIsUpdated] = useState(false);
  const [open, setOpen] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  useEffect(() => {
    if (userInfo?.id && storedData?.id) {
      navigate('/user-info/')
    }
  }, [storedData, userInfo])
  useEffect(() => {
    if (storedData) {
      setUserInfo(JSON.parse(storedData));
    }
  }, [])
  const requiredFields = [
    'email',
    'firstName',
    'familyName',
    'firstNameEn',
    'familyNameEn',
    'passportNo',
    'birthday',
    'passportExpiry',
    'img'
  ];
  const [validateStatus, setValidateStatus] = useState({
    email: { valid: true, message: '' },
    firstName: { valid: true, message: '' },
    middleName: { valid: true, message: '' },
    familyName: { valid: true, message: '' },
    middleNameEn: { valid: true, message: '' },
    firstNameEn: { valid: true, message: '' },
    birthday: { valid: true, message: '' },
    familyNameEn: { valid: true, message: '' },
    passportNo: { valid: true, message: '' },
    passportExpiry: { valid: true, message: '' },
    phone: { valid: true, message: '' },
    address: { valid: true, message: '' },
    job: { valid: true, message: '' },
    emergencyContact: { valid: true, message: '' },
    emergencyPerson: { valid: true, message: '' },
  });

  useEffect(() => {
    const isFormReady = () => {
      const isAllValid = Object.values(validateStatus).every(v => v.valid);

      const isUserInfoComplete = requiredFields.every(key => {
        const val = userInfo[key];
        return val !== undefined && val !== null && String(val).trim() !== '';
      });

      return isAllValid && isUserInfoComplete;
    };

    setIsUpdated(isFormReady());
  }, [validateStatus, userInfo]);

  const registerHandler = () => {
    setVerifying(true)

    //前後の空白削除
    const updateData = Object.fromEntries(
      Object.entries(userInfo).map(([key, value]) => {
        if (typeof value === 'string') {
          return [key, value.trim()];
        }
        return [key, value];
      })
    );

    fetch(gasPath, {
      method: "POST",
      body: JSON.stringify({
        jacStatus: "update",
        token: token,
        ...updateData,
        membership: `temporary`
      }),
      headers: {
        "Content-Type": "text/plain"
      }
    })
      .then(res => res.text())                     // レスポンス全体を文字列として取得
      .then(text => JSON.parse(text))
      .then(data => {
        if (data.status === 'success') {
          const newData = { ...data.userInfo, status: 'temporary' }
          // 仮登録として登録される
          setUserInfo(newData)
          sessionStorage.setItem("jacUserCore", JSON.stringify(newData));
          setOpen(true)
          if (data.userInfo?.id) {
            fetch(`${restPath}/wp-json/${prefix}base64/v1/registerImgData`, {
              method: "POST",
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: data.userInfo?.id,
                imgData: newData.img,
              })
            })
              .then(res => res.json())
              .then(wpData => {
                if (wpData.status === `success`) {
                  console.log("画像保存成功:", wpData.message);
                } else {
                  console.warn("画像保存失敗:", wpData);
                }
              })
              .catch(err => {
                console.error("WordPress REST API:", err);
              });
          }
        } else {
          console.warn("データ 保存失敗:", data);
          alert(`更新失敗しました`)
        }
        setVerifying(false);
      })
      .catch(err => {
        console.error("Error in fetch:", err);
        alert("更新失敗しました");
        setVerifying(false);
      });
  }

  return <>
    <ul className="breadcrumb">
      <li>新規登録</li>
    </ul>
    <PictureUpload setUserInfo={setUserInfo} userInfo={userInfo}></PictureUpload>
    <p style={{ textAlign: `right`, margin: `16px auto`, fontSize: `12px` }}><span style={{ color: `var(--red)` }}>※</span>は必須です。</p>
    <dl className="dl">
      <UseInfoEmail userInfo={userInfo} isEdit={false} setUserInfo={setUserInfo} validateStatus={validateStatus} setValidateStatus={setValidateStatus}></UseInfoEmail>
      <UseInfoMain userInfo={userInfo} isEdit={true} setUserInfo={setUserInfo} validateStatus={validateStatus} setValidateStatus={setValidateStatus}></UseInfoMain>
      <UseInfoBirthday userInfo={userInfo} setUserInfo={setUserInfo} validateStatus={validateStatus} setValidateStatus={setValidateStatus}></UseInfoBirthday>
    </dl>
    <h2>旅券情報</h2>
    <UseInfoPassport userInfo={userInfo} isEdit={true} setUserInfo={setUserInfo} validateStatus={validateStatus} setValidateStatus={setValidateStatus}></UseInfoPassport>
    <h2>その他</h2>
    <UseInfoOthers userInfo={userInfo} isEdit={true} setUserInfo={setUserInfo} validateStatus={validateStatus} setValidateStatus={setValidateStatus}></UseInfoOthers>
    <h2>緊急連絡先</h2>
    <div style={keyboardOpen ? { paddingBottom: `300px` } : { paddinBottom: 0 }}>
      <UserInfoEmergency userInfo={userInfo} isEdit={true} setUserInfo={setUserInfo} validateStatus={validateStatus} setValidateStatus={setValidateStatus} setKeyboardOpen={setKeyboardOpen}></UserInfoEmergency>
    </div>
    <p style={{ textAlign: `center`, marginTop: `12px`, display: `flex`, justifyContent: `center`, gap: `16px` }}>
      <Button
        onClick={registerHandler}
        disabled={
          !isUpdated
        }
        style={{ background: `var(--red)`, color: `#fff`, fontSize: `18px` }}
        sx={{ width: "300px" }}

      >登録する</Button>
    </p>
    {verifying && <div className="register"><img src={`${imgPath}/images/spinner.svg`} alt="" width={100} height={110} /></div>}
    <NavPopup open={open} setOpen={setOpen} userInfo={userInfo}></NavPopup>
  </>
}
export default Register;


const NavPopup = ({ open, setOpen, userInfo }) => {
  const navigate = useNavigate();
  const goMovement = (val = ``) => {
    console.log(val)
    if (val === `payment`) {
      navigate('/payment/')
    } else {
      navigate('/user-info/')
    }
    sessionStorage.setItem("jacUserCore", JSON.stringify(userInfo));
    setOpen(false);
  };

  return <Dialog open={open} onClose={goMovement}>
    <DialogTitle>{userInfo?.id}で仮登録いたします</DialogTitle>
    <DialogContent>
      <ul>
        <li>1週間（{userInfo.expiry}まで）の無料をお試しいただけます。お試し期間中は優待店の割引を受けることができます。</li>
        <li>お試し期間にお支払いが確認できない場合、会員資格は失効します。</li>
        <li>会員資格失効後、3ヶ月更新がない場合は登録データは自動で削除されます。</li>
      </ul>
      <div style={{ padding: `16px 0 0`, display: `flex`, gap: `8px`, justifyContent: `center` }}>
        <Button
          sx={{ width: "100%" }}
          onClick={() => goMovement(`payment`)}
          style={{ background: `var(--blue)`, color: `#fff` }}>
          支払いに進む
        </Button>
        <Button
          sx={{ width: "100%" }}
          onClick={() => goMovement()}
          style={{ background: `var(--border)`, color: `#fff` }}>
          仮登録で無料期間を試す
        </Button>
      </div>
    </DialogContent>
  </Dialog>
}
